<div class="text-info">
  <p><b>{{info.question}}</b>:</p>
  <p> {{info.response}}</p>
</div>

